import React, { memo } from 'react';
import {
  useEnginePagination,
  UseEnginePaginationSelector
} from '@surveycake/react-logic-engine';
import { useStyles } from './styles';

const breadcrumbSelector: UseEnginePaginationSelector<string[]> = pagination =>
  pagination.breadcrumb;

function Breadcrumb() {
  const breadcrumb = useEnginePagination(breadcrumbSelector);
  const styles = useStyles();

  return (
    <div className={styles.breadcrumbContainer} aria-label="breadcrumb">
      {breadcrumb.map((bread, index) => {
        if (!bread) {
          return null;
        }

        const style =
          index > 0
            ? {
                marginLeft: index * 20
              }
            : undefined;

        return (
          <div key={index} className={styles.breadcrumb} style={style}>
            {bread}
          </div>
        );
      })}
    </div>
  );
}

export default memo(Breadcrumb);
